
import { defineComponent, onBeforeMount, PropType, reactive } from 'vue'

// UI
import Modal from '@/common/components/UI/Modal/index.vue'
import TheSelect from '@/common/components/UI/TheSelect/index.vue'

// Types
import { VerificationTypeT } from '@/core/types/verification.types'
import { CompanyT } from '@/core/types/companies.types'

// Realisations
import { verification } from '@/core/realisations/verification.realisation'
import { companies } from '@/core/realisations/companies.realisation'

// Composable
import useNotifications from '@/common/composable/useNotifications'

// Validation
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'

export default defineComponent({
    components: {
        Modal,
        TheSelect,
    },
    props: {
        company: {
            type: [null, Object] as PropType<null | CompanyT>,
            default: null,
        },
    },
    emits: ['cancel', 'enabled'],
    setup(props, context) {
        const notifications = useNotifications()

        const state = reactive({
            is_loading: false,
            type_id: null as number | null,
        })

        const state_form$ = useVuelidate(
            {
                type_id: { required },
            },
            state
        )

        const verification_types = reactive({
            is_loading: false,
            is_failed: false,
            list: [] as VerificationTypeT[],
        })

        const loadVerificationTypes = async () => {
            try {
                verification_types.is_loading = true

                const response = await verification.getTypes()
                verification_types.list = response.data

                verification_types.is_failed = false
            } catch (error) {
                notifications.notifyError({
                    error,
                    title: 'При получении типов верификации произошла ошибка',
                })
                verification_types.is_failed = true
            } finally {
                verification_types.is_loading = false
            }
        }

        onBeforeMount(loadVerificationTypes)

        const emitCancel = () => {
            context.emit('cancel')
        }

        const emitEnabled = () => {
            if (!props.company) return

            context.emit('enabled', {
                company_id: props.company.id,
                type_id: state.type_id,
            })
        }

        const enableVerification = async () => {
            state_form$.value.$touch()
            if (state_form$.value.$invalid) return

            if (!props.company) {
                return
            }

            try {
                state.is_loading = true

                await companies.enableVerification(props.company.id, state.type_id as number)

                notifications.notify({
                    title: 'Верификация включена',
                    description: `Верификация для компании ${props.company.name} включена`,
                    type: 'success',
                })

                emitEnabled()
            } catch (error) {
                notifications.notifyError({
                    error,
                    title: 'При включении верификации произошла ошибка',
                })
            } finally {
                state.is_loading = false
            }
        }

        return {
            state,
            state_form$,
            verification_types,
            loadVerificationTypes,
            emitCancel,
            enableVerification,
        }
    },
})
